<template>
  <div class="main-container">
    <bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
      <div class="table-operations" slot="ope">
        <el-button type="primary" @click="uploadAttach">{{$t("cost.invoice001")}}</el-button><!-- AI识别发票 -->
        <el-button type="primary" @click="addInvoice">{{$t("cost.invoice002")}}</el-button><!-- 添加其他票据 -->
        <el-button type="primary" @click="deleteInvoices" v-show="statusType=='usable' || statusType == 'uncheck'">{{$t("cost.invoice003")}}</el-button><!-- 批量删除 -->
        <!--<el-button type="primary" @click="testFunc" style="float: right;margin: 0 5px;">测试专用按钮</el-button>-->
      </div>
<!--      <bsp-grid-->
<!--        class="bsp-grid"-->
<!--        ref="itemListTable"-->
<!--        :demoLoading.sync="demoLoading"-->
<!--        :tableColumns.sync="tableColumns"-->
<!--        :tableDatas.sync="tableDatas"-->
<!--        @tableRefresh="tableRefresh"-->
<!--        @updateColumn="updateColumn"-->
<!--        @checkbox-all="selectAllEvent"-->
<!--        @checkbox-change="selectChangeEvent"-->
<!--        :pagerConfig="pagerConfig"-->
<!--        :checkbox-config="{ checkMethod: checkboxMethod, highlight: true, range: true}"-->
<!--      >-->
<!--        <template v-slot:discernCusIdText="{row}">-->
<!--          <el-link type="primary" @click="toEditPage(row, 'view')" style = "text-overflow: ellipsis;white-space: nowrap;display:block;overflow: hidden;" >{{ row.cusName }}</el-link>-->
<!--          &lt;!&ndash;        <span>{{ discernCusMap[row.cusId]}}</span>&ndash;&gt;-->
<!--        </template>-->
<!--        <template v-slot:discernStatusText="{row}">-->
<!--          <span>{{ dicts.codeMap[row.status]}}</span>-->
<!--        </template>-->
<!--        <template v-slot:discernCheckStatusText="{row}">-->
<!--          <span>{{ dicts.codeMap[row.checkStatus]}}</span>-->
<!--        </template>-->

<!--        <template v-slot:operation="{row}">-->
<!--          <el-image class="gridOptIcon" v-show="statusType=='usable' || statusType == 'used'" :src="viewIconUrl" title="查看票据" @click="viewInvoice(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show="statusType=='usable' || statusType == 'uncheck'" :src="eidtIconUrl" title="编辑/确认票据" @click="editInvoice(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show=" statusType == 'uncheck' && invoiceVerifySwitch == '00901' && row.status == '80510004'" :src="lockIconUrl" title="票据验真" @click="makeCloudInvoiceFolderVerify(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show="statusType=='usable' || statusType == 'uncheck'" :src="deleteIconUrl" title="删除票据" @click="deleteInvoice(row.id, row)" ></el-image>-->

<!--        </template>-->
<!--      </bsp-grid>-->
      <bsp-table
        class="bsp-grid"
        ref="invoiceListTable"
        v-loading="demoLoading"
        :data.sync="tableDatas"
        element-loading-text="拼命加载中"
        :ciic-data-filter.sync="listQuery"
        @ciic-data-refresh="ciicDataRefresh"
        @ciic-data-select="ciicDataSelect"
        element-loading-spinner="el-icon-loading"
        show-header-overflow
        show-overflow
      >
        <vxe-table-column type="checkbox" width="50" fixed="left" align="center"></vxe-table-column>

        <bsp-table-column field="invoiceHm" :title="$t('cost.invoice004')" align="center" :slot-filter="true" filter-type="input" ><!-- 票据号码 -->
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceHm }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="invoiceTypeTxt" :title="$t('cost.invoice005')" align="center" :slot-filter="true" filter-type="input" ><!-- 票据类型 -->
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceTypeTxt }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="startDate" :title="$t('cost.invoice006')" align="center" :slot-filter="true" filter-type="input" ><!-- 票据日期 -->
          <template slot-scope="scope">
            <span>{{ scope.row.startDate }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="includeTax" :title="$t('cost.invoice007')" align="center" :slot-filter="true" filter-type="input" ><!-- 票据金额 -->
          <template slot-scope="scope">
            <span>{{ scope.row.includeTax | moneyFilterRMB }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="createTime" :title="$t('cost.invoice008')" align="center" :slot-filter="true" filter-type="input" ><!-- 录入日期 -->
          <template slot-scope="scope">
            <span>{{ scope.row.createTime  }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="msg" :title="$t('cost.invoice009')" align="center" :slot-filter="true" filter-type="input" ><!-- 说明 -->
          <template slot-scope="scope">
            <span>{{ scope.row.msg  }}</span>
          </template>
        </bsp-table-column>

        <vxe-table-column field="status" :title="$t('cost.invoice010')" align="center" :filters="[{ data: '' }]"  ><!-- 发票状态 -->
          <template #filter="{ $panel, column }">
            <el-select clearable  filterable v-model="column.filters[0].data" @change="changeStatusFilter($event)" size="medium" @clear="clearData">
              <el-option v-for="(item) in templateStatusList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ dicts.codeMap[scope.row.status]  }}</span>
          </template>
        </vxe-table-column>

        <bsp-table-column field="checkStatus" :title="$t('cost.invoice011')" align="center"  ><!-- 验真状态 -->
          <template slot-scope="scope">
            <span>{{ dicts.codeMap[scope.row.checkStatus]  }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="verifyMsg" :title="$t('cost.invoice012')" align="center" :slot-filter="true" filter-type="input" ><!-- 验真说明 -->
          <template slot-scope="scope">
            <span>{{ scope.row.verifyMsg  }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="operation" :title="$t('cost.invoice013')" align="center" minWidth='140px'><!-- 操作 -->
          <template slot-scope="scope">
              <el-image class="gridOptIcon" v-show="statusType=='usable' || statusType == 'used'" :src="viewIconUrl" :title="$t('cost.invoice014')" @click="viewInvoice(scope.row.id, scope.row)" ></el-image><!-- 查看票据 -->
              <el-image class="gridOptIcon" v-show="statusType=='usable' || statusType == 'uncheck'" :src="eidtIconUrl" :title="$t('cost.invoice015')" @click="editInvoice(scope.row.id, scope.row)" ></el-image><!-- 编辑/确认票据 -->
              <el-image class="gridOptIcon" v-show=" statusType == 'uncheck' && invoiceVerifySwitch == '00901' && scope.row.status == '80510004'" :src="lockIconUrl" :title="$t('cost.invoice016')" @click="makeCloudInvoiceFolderVerify(scope.row.id, scope.row)" ></el-image><!-- 票据验真 -->
              <el-image class="gridOptIcon" v-show="statusType=='usable' || statusType == 'uncheck'" :src="deleteIconUrl" :title="$t('cost.invoice017')" @click="deleteInvoice(scope.row.id, scope.row)" ></el-image><!-- 删除票据 -->
          </template>
        </bsp-table-column>

      </bsp-table>
    </bsp-tabs>
    <upload-attach ref="uploadAttach" @reload="doUploadSubmit"></upload-attach>

    <invoice-edit ref="invoiceEdit" class="invoiceEdit" @reload="doEditSubmit"></invoice-edit>

    <confirm-invoice ref="confirmInvoice" class="confirmInvoice" @reload="doConfirmSubmit"></confirm-invoice>
  </div>
</template>

<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs-v2"
  import viewIcon from '@/assets/img/miniuiIcon/search_2.gif'
  import eidtIcon from '@/assets/img/miniuiIcon/edit_on.gif'
  import deleteIcon from '@/assets/img/miniuiIcon/delete_on.gif'
  import lockIcon from '@/assets/img/miniuiIcon/lock.png'
  import { getUserCusList, getUserCusListZz, getAllCusList} from "@/api/sys/cus";
  import {getCloudCostDetailMobileList, deleteCloudInvoiceFolder, saveCloudInvoiceFolder, makeCloudInvoiceFolderVerify} from "@/api/cost/cost";
  import UploadAttach from "@/views/cost/components/UploadAttach";
  import ConfirmInvoice from "@/views/cost/costInvoiceFolder/confirmInvoiceList";
  import bspGrid from "@/components/bsp/bsp-grid/grid";
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import { downloadFile } from '@/util/util'
  import {mapGetters} from 'vuex';
  import {formatDateSubstr10, formatDateSimple} from "@/util/date_format.js"
  import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
  import InvoiceEdit from "@/views/cost/costInvoiceFolder/invoiceFolderEdit";
  export default {
  name: "costInvoiceList",
  components: { bspTabs ,bspTable,bspTableColumn,  UploadAttach, InvoiceEdit, ConfirmInvoice },
  data() {
    return {
      tabList: [
        { title: this.$t("cost.invoice018"), name: 'usable' },//待使用
        { title: this.$t("cost.invoice019"), name: 'uncheck' },//待复核
        { title: this.$t("cost.invoice020"), name: 'used'}//已使用
      ],
      tabIndex: 'usable',
      currentTab: 'usable',
      searchForm:{},
      searchParams: {},
      tableDatas: [],
      tableColumns: [],
      // filtersData: { page: 1, limit: 20 },
      // pagerConfig: {
      //   total: 0,
      //   page: 1,
      //   limit: 20
      // },
      listQuery:{
        limit: 20,
        page: 1,
        total: 0,
        filters: []
      },
      demoLoading: false,
      loadingImport: false,
      loadingBtn: false,
      multipleSelection: [],
      optParams: {},
      statusType: 'usable',
      viewIconUrl : viewIcon,
      lockIconUrl : lockIcon,
      eidtIconUrl : eidtIcon,
      deleteIconUrl : deleteIcon,
      invoiceVerifySwitch : '00900',
      templateStatusList: [
        {id:"80510002", name:"未确认"},
        {id:"80510004", name:"待验真"},
        {id:"80510005", name:"无需验真"},
        {id:"80510006", name:"已验真"},
        {id:"80510007", name:"待使用"},
        {id:"80510008", name:"已使用"},
      ]
    };
  },
  created() {
    if(this.optParams && this.optParams.type == "cost"){
    }else{
      //this.getColumn();
      this.init();
    }
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab.name;
      this.statusType = tab.name
      //this.getColumn();
      this.init();
    },
    testFunc(){
      // this.optParam = {
      //   cdmId : '',
      // };
      //console.log("toEditpage");
      //console.log(this.optParam);
      // this.$router.push({path:'/costInvoiceFolder/invoiceFolderEdit',query:this.optParam});

      let params = {
        ids: "4028974b98f44a540198f4544ff0000b,4028974b98f44a540198f4544ff7000c,4028974b98f44a540198f45447b30004",
        from: "invoiceList",
      }
      this.$refs.confirmInvoice.visible = true;
      this.$refs.confirmInvoice.optParams = params;
      this.$refs.confirmInvoice.init();
    },
    addInvoice(){
      let params = {
        id: null,
        from: "invoiceList",
        opt:"add"
      }
      this.$refs.invoiceEdit.visible = true;
      this.$refs.invoiceEdit.params = params;
      this.$refs.invoiceEdit.init();
    },
    editInvoice(id, row){
      let params = {
        id: id,
        from: "invoiceList",
        opt:"edit"
      }
      this.$refs.invoiceEdit.visible = true;
      this.$refs.invoiceEdit.params = params;
      this.$refs.invoiceEdit.init();
    },
    viewInvoice(id, row){
      let params = {
        id: id,
        from: "invoiceList",
        opt:"view"
      }
      this.$refs.invoiceEdit.visible = true;
      this.$refs.invoiceEdit.params = params;
      this.$refs.invoiceEdit.init();
    },
    // 导出
    exportExcel() {
      this.demoLoading = true;
      var tdStatusArr = this.searchForm.tdStatusArr;
      var tdStatus = "";
      if(tdStatusArr != null && tdStatusArr.length > 0){
        for(var i = 0; i < tdStatusArr.length; i++){
          tdStatus += tdStatusArr[i] + ",";
        }
      }

      let params = {
        // ...this.filtersData,
        searchParams : {
          tdStatus : tdStatus,
          cusId : this.searchForm.cusId,
          appliId : this.searchForm.appliId,
          handlerId : this.searchForm.handlerId,
          startEndDate : this.searchForm.startDate,
          endEndDate : this.searchForm.endDate,
          userTdRole : this.userTdRole,
          startCompleteDate: this.searchForm.startCompleteDate,
          endCompleteDate: this.searchForm.endCompleteDate,
          felId : this.searchForm.felId,
          tdType: this.searchForm.tdType,
          accountMonth: this.searchForm.accountMonth
        }
      }
      // exportTaskList(params)
      //   .then((res) => {
      //     if (res.headers['content-disposition'] === undefined) {
      //       this.demoLoading = false
      //       this.$message.error('账单下载失败,请联系运维人员！')
      //     } else {
      //       downloadFile(res)
      //       this.demoLoading = false
      //       this.$message.success("下载成功！");
      //     }
      //   })
    },
    deleteInvoice(id, row) {

      var that = this;

      this.$confirm(this.$t("homepage.txt022") + "?", this.$t("homepage.txt017"), { //您确定要删除文件?  提示
        confirmButtonText: this.$t("homepage.txt018"), //确认
        cancelButtonText: this.$t("homepage.txt019"),//取消
        type: 'warning'
      }).then(() => {
        that.deleteCloudInvoiceFolder(id, row);
      }).catch(() => {
      });


    },
    deleteCloudInvoiceFolder(id, row){
      let params = {
        mainForm : {id : id}
      }

      deleteCloudInvoiceFolder(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$message.success(this.$t('homepage.txt023')); //删除成功

            if(this.tableDatas.length == 1 && this.listQuery.page > 1){
              // this.filtersData.page = this.filtersData.page - 1;
              // this.pagerConfig.page = this.pagerConfig.page - 1;
              this.listQuery.page = this.listQuery.page - 1;
            }

            this.getData() ;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    makeCloudInvoiceFolderVerify(id, row){
      this.demoLoading = true;
      let params = {
        mainForm : {id : id}
      }

      makeCloudInvoiceFolderVerify(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            if(result.data){
              this.$message.warning(this.$t('homepage.txt025')+"!"+ this.$t('homepage.txt026') +"：" + result.data); // 验真完成   但是存在异常信息
            }else{
              this.$message.success(this.$t('homepage.txt025'));//验真完成
            }

            this.getData() ;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    // 查询
    handleSearch() {
      // this.pagerConfig.page = 1;
      // this.filtersData.page = 1;
      this.listQuery.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },
    handleReset() {
      this.searchForm = {};
      this.initSelectForm();
      // this.pagerConfig.page = 1;
      // this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },
    changeStatusFilter(e){
      if (e) {
        this.listQuery['filters'] =  [{operator: "=", column: "status", value:e}]
        this.listQuery.page = 1;
        this.getData();
      }
    },
    clearData() {
      this.listQuery.filters = [];
      this.listQuery.page = 1;
      this.getData();
    },
    // 获取表头
    // getColumn() {
    //   let column = [
    //     {
    //       type: "checkbox",
    //       setId: "",
    //       width: 50,
    //     },{
    //       type: "",
    //       field: "invoiceHm",
    //       title: "票据号码",
    //     },{
    //       type: "",
    //       field: "invoiceTypeTxt",
    //       title: "票据类型",
    //     },{
    //       type: "",
    //       field: "startDate",
    //       title: "票据日期",
    //     },{
    //       type: "",
    //       field: "includeTax",
    //       title: "票据金额",
    //     },{
    //       type: "",
    //       field: "createTime",
    //       title: "录入日期",
    //     },{
    //       type: "",
    //       field: "msg",
    //       title: "说明",
    //     },{
    //       type: "",
    //       field: "status",
    //       title: "发票状态",
    //       params:{slot:'discernStatusText'}
    //     },{
    //       type: "",
    //       field: "checkStatus",
    //       title: "验真状态",
    //       params:{slot:'discernCheckStatusText'}
    //     },{
    //       type: "",
    //       field: "verifyMsg",
    //       title: "验真说明",
    //     },{
    //       type: "",
    //       field: "",
    //       title: "操作",
    //       minWidth : '140px',
    //       params:{slot:'operation'}
    //       //params:{slot:'discernShelvedFlagText'}
    //     }
    //   ];
    //   this.$set(this,"tableColumns",column);
    // },
    init() {
      // if(this.$route.query.from){
      //   alert(this.$route.query.tdStatus);
      // }
      // var user = this.$store.state.user.userInfo;
      // this.userId = user.userId;
      this.listQuery = {
        limit: 20,
          page: 1,
          total: 0,
          filters: []
      };
     this.getData();

    },
    uploadAttach(){
      let params = {
        batchId: null,
        btnType: "",
        type: "invoiceFolderOcr",
      }
      this.$refs.uploadAttach.visible = true;
      this.$refs.uploadAttach.params = params;
      this.$refs.uploadAttach.init();
    },
    deleteInvoices() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        return this.$message.error(this.$t('homepage.txt027')) //至少选择一条数据
      }

      let idsArray =this.multipleSelection.map(item=> item.id)
      var ids = "";
      idsArray.forEach(id=> {
        ids += id + ",";
      })

      this.deleteInvoice(ids, null);
    },
    //============================================================
    // 获取数据
    getData() {
      this.demoLoading = true;

      let params = {
        ...this.listQuery,
        searchParams : {
          endDate: this.searchForm.endDate,
          startDate: this.searchForm.startDate,
          timeType: "80130001",
          useType: "0",
          statusType: this.statusType,
        }
      }
      console.log(params)

      getCloudCostDetailMobileList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.tableDatas = result.data.records;
            // this.pagerConfig.total = result.data.total;
            this.listQuery.total = result.data.total;
            this.invoiceVerifySwitch = result.data.invoiceVerifySwitch;

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    //bsp-table分页筛选
    ciicDataRefresh() {
      console.log("ciicDataRefresh-listQuery", this.listQuery)
      this.getData();
    },
    ciicDataSelect(data){
      console.log("ciicDataSelect", data)
      this.multipleSelection = data;
    },
    //bsp-grid获取请求筛选数据/分页
    tableRefresh(filter, cal) {
      // this.filtersData = filter;
      // this.pagerConfig.page = filter.page;
      // this.pagerConfig.limit = filter.limit;
      this.getData(cal);
    },
    updateColumn(columns) {
      //console.log(columns);
    },
    selectAllEvent({ checked, records, selection }) {
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    // 禁用表格复选框
    checkboxMethod({row}) {
      return true;
      //return row.discernStatus == '80130003';
    },

    doUploadSubmit(val) {
      console.log("doUploadSubmit", val);
      // this.optParam = {
      //   fileList: val
      // };
      //
      // this.$router.push({path:'/costInvoiceFolder/confirmInvoiceList',query:this.optParam});

      let params = {
        ids: null,
        from: "invoiceList",
        fileList: val
      }
      this.$refs.confirmInvoice.visible = true;
      this.$refs.confirmInvoice.optParams = params;
      this.$refs.confirmInvoice.init();
    },
    doEditSubmit() {
      this.init();
    },
    doConfirmSubmit(){
      this.init()
    },
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),
  }
};
</script>
<style lang="scss" scoped>
</style>
